import React, { useEffect } from "react";
import { ToggleLeft, ToggleRight } from "lucide-react";
import { useTheme } from "../context/ThemeContext";

const Features = () => {
  const { isDarkMode, toggleTheme } = useTheme();

  useEffect(() => {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      window.location.href = "/login";
    }
  }, []);

  const features = [
    {
      id: 1,
      name: "Dark Mode",
      description: "Enable dark mode theme",
      enabled: isDarkMode,
      onToggle: toggleTheme,
    },
  ];

  return (
    <div className="flex flex-col gap-5">
      <div className="flex items-center justify-between">
        <h2
          className={`text-2xl font-bold ${
            isDarkMode ? "text-white" : "text-gray-900"
          }`}
        >
          Feature Management
        </h2>
      </div>

      <div
        className={`${
          isDarkMode ? "bg-black border-zinc-800" : "bg-white border-gray-200"
        } border rounded-xl overflow-hidden`}
      >
        {features.map((feature, idx) => (
          <div
            key={feature.id}
            className={`p-5 flex items-center justify-between transition-colors ${
              isDarkMode ? "hover:bg-zinc-900" : "hover:bg-gray-50"
            } ${
              idx !== features.length - 1
                ? isDarkMode
                  ? "border-b border-zinc-800"
                  : "border-b border-gray-200"
                : ""
            }`}
          >
            <div>
              <h3
                className={`font-semibold mb-1 ${
                  isDarkMode ? "text-white" : "text-gray-900"
                }`}
              >
                {feature.name}
              </h3>
              <p
                className={`text-sm ${
                  isDarkMode ? "text-gray-400" : "text-gray-600"
                }`}
              >
                {feature.description}
              </p>
            </div>
            <button
              className="ml-4"
              onClick={feature.onToggle}
              aria-label={`Toggle ${feature.name}`}
            >
              {feature.enabled ? (
                <ToggleRight size={40} className="text-green-400" />
              ) : (
                <ToggleLeft size={40} className="text-gray-600" />
              )}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Features;
